/* eslint-disable no-unused-vars */
/* eslint-disable no-else-return */
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/Common/Dialog';

export default function SaveChangePopup({
  status,
  onClose,
}) {
  if (status === 1) {
    return (
      <Dialog
        open
        title="貼心提醒"
        content={(
          <div>
            <div>
              <span>
                您已調整廣告單元設定，單元狀態將恢復成未排程廣告。
              </span>
            </div>
          </div>
        )}
        submitText="確認"
        onSubmit={onClose}
        onClose={onClose}
      />
    );
  } else if (status === 2) {
    return (
      <Dialog
        open
        title="貼心提醒"
        content={(
          <div>
            <div>
              <span>
                您已調整廣告單元設定，單元狀態將恢復成未排程廣告。
              </span>
            </div>
            <br />
            <div>
              <span>
                您的廣告單元已完成素材設定
              </span>
            </div>
            <div>
              <span>
                請按下「
              </span>
              <span style={{ color: 'red' }}>
                發送上稿需求
              </span>
              <span>
                」，設定您的廣告走期。
              </span>
            </div>
            <div>
              <span>
                設定走期後須預留
              </span>
              <span style={{ color: 'red' }}>
                兩個工作天
              </span>
              <span>
                ，若有問題請洽詢專員。
              </span>
            </div>
          </div>
        )}
        submitText="確認"
        onSubmit={onClose}
        onClose={onClose}
      />
    );
  }

  return (
    <Dialog
      open
      title="貼心提醒"
      content={(
        <div>
          <div>
            <span>
              您的廣告單元已完成素材設定
            </span>
          </div>
          <div>
            <span>
              請按下「
            </span>
            <span style={{ color: 'red' }}>
              發送上稿需求
            </span>
            <span>
              」，設定您的廣告走期。
            </span>
          </div>
          <div>
            <span>
              設定走期後須預留
            </span>
            <span style={{ color: 'red' }}>
              兩個工作天
            </span>
            <span>
              ，若有問題請洽詢專員。
            </span>
          </div>
        </div>
      )}
      submitText="確認"
      onSubmit={onClose}
      onClose={onClose}
    />
  );
}

SaveChangePopup.propTypes = {
  status: PropTypes.number,
  onClose: PropTypes.func,
};

SaveChangePopup.defaultProps = {
  status: 0,
  onClose: () => {},
};
